import { render, staticRenderFns } from "./layouts.one-page.6bef2fe4.vue?vue&type=template&id=13aafe49&scoped=true&"
import script from "./layouts.one-page.6bef2fe4.vue?vue&type=script&lang=ts&"
export * from "./layouts.one-page.6bef2fe4.vue?vue&type=script&lang=ts&"
import style0 from "./layouts.one-page.6bef2fe4.vue?vue&type=style&index=0&id=13aafe49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aafe49",
  null
  
)

export default component.exports